/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiDocument,
    InternalApiDocumentFromJSON,
    InternalApiDocumentToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
    InternalDocumentsPage,
    InternalDocumentsPageFromJSON,
    InternalDocumentsPageToJSON,
} from '../models';

export interface DeleteDocumentRequest {
    personId: string;
    documentId: number;
}

export interface DownloadDocumentRequest {
    personId: string;
    documentId: number;
}

export interface FindAllDocumentsRequest {
    personId: string;
    page: number;
    size: number;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
}

export interface UploadDocumentRequest {
    personId: string;
    file: Blob;
}

/**
 * 
 */
export class DocumentInternalApi extends runtime.BaseAPI {

    /**
     * Delete document
     */
    async deleteDocumentRaw(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiDocument>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling deleteDocument.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling deleteDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/documents/{documentId}`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiDocumentFromJSON(jsonValue));
    }

    /**
     * Delete document
     */
    async deleteDocument(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit): Promise<InternalApiDocument> {
        const response = await this.deleteDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download document content
     */
    async downloadDocumentRaw(requestParameters: DownloadDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling downloadDocument.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling downloadDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/documents/{documentId}`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download document content
     */
    async downloadDocument(requestParameters: DownloadDocumentRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.downloadDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all documents
     */
    async findAllDocumentsRaw(requestParameters: FindAllDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalDocumentsPage>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findAllDocuments.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllDocuments.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllDocuments.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/documents`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalDocumentsPageFromJSON(jsonValue));
    }

    /**
     * Fetches all documents
     */
    async findAllDocuments(requestParameters: FindAllDocumentsRequest, initOverrides?: RequestInit): Promise<InternalDocumentsPage> {
        const response = await this.findAllDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Uploads new document
     */
    async uploadDocumentRaw(requestParameters: UploadDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiDocument>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling uploadDocument.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/documents`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiDocumentFromJSON(jsonValue));
    }

    /**
     * Uploads new document
     */
    async uploadDocument(requestParameters: UploadDocumentRequest, initOverrides?: RequestInit): Promise<InternalApiDocument> {
        const response = await this.uploadDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
